import type { ReactNode } from 'react';

export const symbol_download_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-80q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h580q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q782.75-80 770-80H190Zm276-181.5q-6-2.5-11-8.5L237-552q-11-15-3.5-31.5T260-600h99v-250q0-12.75 8.63-21.38Q376.25-880 389-880h180q12.75 0 21.38 8.62Q599-862.75 599-850v250h100q19 0 26.5 16.5T722-552L503-270q-5 6-11 8.5t-13 2.5q-7 0-13-2.5Zm13-76.5 144-185h-84v-297H419v297h-84l144 185Zm0-185Z"
		/>
	</svg>
);
